import { TThunkAction } from '../../types/redux/thunk';
import { setPageLoader } from '../loading';
import { promosRequestAction } from '../promos';

/**
 * Redux action, который запрашивает объявления с текущем состоянием nextJsonQuery
 */
export const promosApplyFiltersRequestAction = (): TThunkAction<Promise<void>> => async dispatch => {
  dispatch(setPageLoader(true));
  await dispatch(promosRequestAction());
  dispatch(setPageLoader(false));
};
